import { paymentSchema, type Payment, type PausePaymentBody } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postPause = (id: string, body: PausePaymentBody): Promise<unknown> =>
  apiRequest<unknown>(`/payments/${id}/pause`, { method: 'POST', body });

export const pausePayment = async (id: string, body: PausePaymentBody): Promise<Payment> =>
  paymentSchema.parse(await postPause(id, body));
